module.exports = __webpack_public_path__ + "img/393742fundacion-manpowergroup.8bf572db.jpg";